import { render, staticRenderFns } from "./ReviewMockBirdsEye.vue?vue&type=template&id=26824126&scoped=true"
import script from "./ReviewMockBirdsEye.vue?vue&type=script&lang=js"
export * from "./ReviewMockBirdsEye.vue?vue&type=script&lang=js"
import style0 from "./ReviewMockBirdsEye.vue?vue&type=style&index=0&id=26824126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26824126",
  null
  
)

export default component.exports